import React, {useEffect} from 'react';
import {Select} from "antd";
import {useDispatch, useSelector} from "react-redux";
import {loadImmeubles} from "../../store/actions/immeubleAction";

function BuildingSelector({onChange}) {
	const immeubles = useSelector((state) => state.immeubles.data);
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(loadImmeubles())
	}, [dispatch])

	const options = immeubles ? immeubles.map(immeuble => ({value: immeuble.immeuble_id, label: immeuble.immeuble_nom})) : [];

	return (
		<Select
			allowClear
			showSearch
			onChange={onChange}
			filterOption={false}
			style={{width: '100%'}}
			options={options}
		/>
	);
}

export default BuildingSelector;